<template>
  <div class="steps">
    <div class="card-body wizard-content">
      <div class="tab-wizard wizard-circle wizard clearfix" role="application" id="steps-uid-0">
        <div class="steps clearfix">
          <ul role="tablist">
            <li
              role="tab"
              @click="changeStep(index)"
              :key="index"
              v-for="(item, index) in steps"
              :class="[step > index?'done':'', step === index?'current':'']"
            >
              <a id="steps-uid-0-t-0" href="javascript:void(0)">
                <span class="step">{{index + 1}}</span>
                {{item.name}}
              </a>
            </li>
          </ul>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import { type } from "os";
export default {
  data: function() {
    return {};
  },
  props: {
    steps: {
      type: Array,
      default: () => {
        return [];
      }
    },
    step: {
      type: Number,
      default: 0
    },
    canClick: {
      type: Boolean,
      default: true
    },
    companyPositionId: {
      type: Number,
      default: 0
    }
  },
  model: {
    prop: "step",
    event: "input"
  },
  methods: {
    changeStep(i) {
      if (this.companyPositionId && this.companyPositionId === -1) {
        this.$awn.alert("请先填写第第一页");
      } else {
        if (this.canClick) {
          this.$emit("input", i);
        } else {
          return false;
        }
      }
    }
  }
};
</script>
<style>
.steps {
  background: #fff;
}
</style>



// WEBPACK FOOTER //
// src/components-base/components-custom/steps/steps.vue